import { render } from "./testlist.vue?vue&type=template&id=5a15a0ca&scoped=true"
import script from "./testlist.vue?vue&type=script&lang=js"
export * from "./testlist.vue?vue&type=script&lang=js"

import "./testlist.vue?vue&type=style&index=0&id=5a15a0ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a15a0ca"]])

export default __exports__